import { toCamelCase, paranthesisRegex } from '@/util/String';


// Shot
export function createShotEvent(description){
  let playerName;
  let event;

  // Penalty Shot
  if(description.includes('Penalty Shot by ')){
    playerName = description.replace("Penalty Shot by ", "").split(" for ")[0];
    event = 'penaltyShot';
  } else{
    playerName = description.replace("Shot by ", "").replace(".", "");
    event = 'shot';
  }

  const player = createPlayerId(playerName);

  return {
    event,
    player
  }
}

// Goal
export function createGoalEvent(description){
  const playerName = description.replace("Goal by ", "").replace(".", "");
  const player = createPlayerId(playerName);

  return {
    event: 'goal',
    player
  }
}

// Save
export function createSaveEvent(description){
  const isRebound = description.includes(' with a ');
  const playerName = description.replace("Stopped by ", "").split("with")[0].trim();
  const player = createPlayerId(playerName);

  return {
    event: 'shotSaved',
    player,
    isRebound
  }
}

// Deflect
export function createDeflectEvent(description){
  const playerName = description.replace("Deflect By ", "").replace(".", "");
  const player = createPlayerId(playerName);

  return {
    event: 'shotDeflect',
    player
  }
}

// Shot Missed
export function createMissedShotEvent(){
  return { event: 'shotMissed' }
};

// Shot Hit Post
export function createShotHitPostEvent(){
  return { event: 'shotHitPost' }
};

// Shot Blocked
export function createShotBlockedEvent(description) {
  const playerName = description.replace("Shot Blocked by ", "").replace(".", "");
  const player = createPlayerId(playerName);
  
  return {
    event: 'shotBlocked',
    player
  }
}

// Shootout
export function createShootoutAttemptEvent(playerName, description){
  const player = createPlayerId(playerName.replace('.', ''));
  let result = {};

  if(description.includes('Goal')) {
    result.type = 'goal';
  }

  if(description.includes('Misses')){
    result.type = 'shotMissed'
  }

  if(description.includes('Stopped')){
    result.type = 'shotSaved';
    result.player = createPlayerId(description.replace('Stopped by ', '').replace('.', ''));
  }

  // Another result?
  if(!result.type){
    result.type = 'shotMissed';
  }

  return {
    event: 'shootoutAttempt',
    player,
    result,
  }
}

// Faceoff
export function createFaceoffEvent(description){
  let [winnerName, loserAndLocation] = description.split(" wins face-off versus ");
  let [loserName, location] = loserAndLocation.split(" in ");

  const winner = createPlayerId(winnerName);
  const loser = createPlayerId(loserName);

  // TODO - grab player from player object.. link ID
  return {
    event: 'faceoff',
    winner,
    loser,
    location,
    description
  }
}

// Hit
export function createHitEvent(description){
  let [loserName, winnerAndTurnover] = description.split(" is hit by ");
  let winnerName, turnover = false;
  
  // If 'and loses puck' is in the description, then it was a turnover
  if(winnerAndTurnover.includes('and loses puck')){
    winnerName = winnerAndTurnover.replace(' and loses puck.', '')
    turnover = true;
  } else {
    winnerName = winnerAndTurnover.replace('.', '');
  }

  const winner = createPlayerId(winnerName);
  const loser = createPlayerId(loserName);

  return {
    event: 'hit',
    winner,
    loser,
    turnover,
    description
  }
}

// Minor Penalty
// Could be "Penalty to Brandon Carlo for instigated a fight."
export function createPenaltyEvent(description) {
  let [type, playerAndInfraction ] = description.split(" to ");
  let [playerName, penalty] = playerAndInfraction.split(" for ");

  if(description.includes('instigated')){
    type = 'Minor';
  } else{
    type = type.split(' ')[0];
  }
  
  const player = createPlayerId(playerName);
  return {
    event: 'penalty',
    type,
    player,
    penalty: penalty.replace('.', ''),
    description
  }
}

// Major Penalty
// Could be "Major Penalty to Jamie Oleksiak for Boarding."
export function createMajorPenaltyEvent(description) {
  let [_, playerAndInfraction] = description.split(" to ");
  let [playerName, penalty] = playerAndInfraction.split(" for ");

  const player = createPlayerId(playerName);
  return {
    event: 'penalty',
    type: 'Major',
    player,
    penalty: penalty.replace('.', ''),
    description
  }
}

// Fight ... TODO
// "Luke Glendening and Brayden Schenn fight to a draw."
// "Scottie Upshall beats up Brandon Carlo."
export function createFightingEvent(description){
  let fighterOneName, fighterTwoName, isDraw = false; 

  if(description.includes(' beats up ')){
    [ fighterOneName, fighterTwoName ] = description.split(' beats up ');
  } else{
    [ fighterOneName, fighterTwoName ] = description.split(' and ');
    fighterTwoName = fighterTwoName.replace(" fight to a draw.", '');
    isDraw = true;
  }

  const fighterOne = createPlayerId(fighterOneName);
  const fighterTwo = createPlayerId(fighterTwoName.replace('.', ''));

  return {
    event: 'fight',
    fighterOne,
    fighterTwo,
    isDraw,
    description
  }
}

// "Penalty to Scottie Upshall for Fighting."
export function createFightingPenaltyEvent(description){
  // If this is an instigator penalty
  if(description.includes('instigated')){
      return createPenaltyEvent(description);
  }

  let playerName = description.replace('Penalty to ', '').replace(' for Fighting.', '');
  const player = createPlayerId(playerName);

  return {
    event: 'penalty',
    type: 'Major',
    penalty: 'Fighting',
    player,
    description
  }
}

export function createMisconductPenaltyEvent(description){
  const text = description.replace('Major / Game Misconduct Penalty to ', '');
  const [playerName, penalty] = text.split(' for ');
  const player = createPlayerId(playerName);
  
  return {
    event: 'misconduct',
    type: 'Misconduct',
    penalty: penalty.replace('.', ''),
    player,
    description
  }
}

export function createEjectedEvent(description){
  let playerName = description.replace(' is ejected from game.', '');
  const player = createPlayerId(playerName);
  
  return {
    event: 'ejected',
    player,
    description
  }
}


// Injury (Anze Kopitar from Sabres is injured at 19:24 of 1st period (Lacerated Right Calf).)
export function createInjuryEvent(description){
  let [ playerAndTeam, timeAndInjury ] = description.split(" is injured at ");
  let playerName = playerAndTeam.split(" from ")[0];
  let injury = paranthesisRegex.exec(timeAndInjury)[1];
  const player = createPlayerId(playerName);

  return {
    event: 'injury',
    player,
    injury,
    description
  }
}

// Offside
export function createOffsideEvent(description){
  return {
    event: 'offside',
    description
  }
}

// Icing
export function createIcingEvent(description){
  let playerName = description.replace("Icing by ", '');
  const player = createPlayerId(playerName);

  return {
    event: 'icing',
    player,
    description
  }
}

// Goalie Pulled
export function createGoaliePulledEvent(description){
  const formatted = description.replace(" is pulled from the net.", '');
  
  let playerName = formatted.split(", ")[1];
  const player = createPlayerId(playerName);

  return {
    event: 'goaliePulled',
    player,
    description
  }
}

// Goalie Returned
export function createGoalieReturnedEvent(description){
  const formatted = description.replace(" was sent back in the game.", '');
  let playerName = formatted.split(" from ")[0];
  const player = createPlayerId(playerName);

  return {
    event: 'goalieReturned',
    player,
    description
  }
}

// Goalie Replaced
export function createGoalieReplacedEvent(description){
  const playerName = description.replace(" enters game", '');
  const player = createPlayerId(playerName);

  return {
    event: 'goalieReplaced',
    player,
    description
  }
}

export function createGoalReviewedEvent(){
  return { event: 'goalReviewed' }
};

export function createGoalReviewNoGoodEvent(){
  return { event: 'goalReviewNoGood' }
};

export function createGoalReviewGoodEvent(){
  return { event: 'goalReviewGood' }
};


function createPlayerId(player){
  return toCamelCase(player.replace(/[^\w\s]/gi, ""));
}